const prefix = 'FLIGHT_EXPERIMENT_LIST';
export const createActionTypes = (resource) => ({
    LOAD: `${prefix}/${resource}/LOAD'`,
    LOADING: `${prefix}/${resource}/LOADING'`,
    LOADED: `${prefix}/${resource}/LOADED'`,
});
export const loadScorecardActionTypes = createActionTypes('LOAD_SCORECARDS');
// Action Creators
export const loadScorecards = (flightId, ids) => {
    return {
        type: loadScorecardActionTypes.LOAD,
        payload: { flightId, ids },
    };
};
export const loadingScorecards = (payload) => {
    return {
        type: loadScorecardActionTypes.LOADING,
        payload: payload,
    };
};
export const loadedScorecards = (flightId, result) => {
    return {
        type: loadScorecardActionTypes.LOADED,
        payload: { flightId, result },
    };
};

//# sourceMappingURL=FlightExperimentList.ducks.js.map
